/* 繁體中文 — Chinese Traditional */
const zhTw = {
  nav: {
    home: '首頁',
    imageConverter: '圖片轉換',
    imageCompressor: '圖片壓縮',
    otherTools: '其他工具',
    resizeImage: '調整圖片大小',
    cropImage: '裁剪圖片',
    photoEditor: '照片編輯器',
    removeBackground: '移除背景',
    watermarkImage: '添加浮水印',
    qrCodeGenerator: 'QR 碼生成器',
    qrCodeScanner: 'QR 碼掃描器',
    aboutUs: '關於我們',
    faceBlur: '人臉模糊',
  },

  hero: {
    heading: '您需要的所有圖片工具',
    subheading: '免費線上工具，用於轉換、壓縮、調整大小、裁剪、編輯和轉換圖片。所有處理都在瀏覽器中完成 — 快速且安全。',
  },

  tools: {
    compressImage: { title: '壓縮圖片', desc: '在保持品質的同時壓縮 JPG、PNG、SVG 和 GIF。' },
    resizeImage: { title: '調整圖片大小', desc: '按百分比或像素調整大小。' },
    cropImage: { title: '裁剪圖片', desc: '輕鬆裁剪 JPG、PNG 和 GIF。' },
    convertToJpg: { title: '轉換為 JPG', desc: '批量將 PNG、GIF、TIF、SVG、WEBP 等轉換為 JPG。' },
    convertFromJpg: { title: '從 JPG 轉換', desc: '將 JPG 圖片轉換為 PNG 和 GIF。' },
    qrCodeGenerator: { title: 'QR 碼生成器', desc: '為 URL、文字、WiFi、聯絡人等生成自訂 QR 碼。' },
    qrCodeScanner: { title: 'QR 碼掃描器', desc: '通過相機或圖片上傳即時掃描 QR 碼。' },
    blurFace: { title: '人臉模糊', desc: '自動偵測並模糊圖片中的人臉以保護隱私。' },
    removeBackground: { title: '移除背景', desc: '以高精度快速移除圖片背景。' },
    watermarkImage: { title: '添加浮水印', desc: '在幾秒鐘內為圖片添加浮水印。' },
  },

  whyChoose: {
    label: '為什麼選擇我們',
    heading: '更智能的圖片編輯方式',
    subheading: '受到全球數千位創作者、設計師和開發者的信賴。',
    reasons: {
      fast: { title: '閃電般快速', desc: '所有處理直接在您的瀏覽器中進行。無需上傳到外部伺服器。' },
      private: { title: '100% 安全私密', desc: '您的文件永遠不會離開您的設備。我們不存儲或分享您的圖片。' },
      noLimits: { title: '無限制，無需註冊', desc: '隨意使用所有工具 — 完全免費。' },
      quality: { title: '專業品質', desc: '我們的演算法提供專業級別的結果。' },
      batch: { title: '批量處理', desc: '一次處理多個文件。' },
      everywhere: { title: '隨處可用', desc: '在桌電、平板和手機上完美運作。' },
    },
    stats: {
      imagesProcessed: '已處理圖片',
      countriesServed: '服務國家',
      uptime: '正常運作時間',
      freeTools: '免費工具',
    },
  },

  footer: {
    tagline: '免費線上圖片工具 — 在幾秒鐘內轉換、壓縮、調整大小、裁剪和編輯圖片。',
    imageTools: '圖片工具',
    moreTools: '更多工具',
    company: '公司',
    contact: '聯絡我們',
    allRightsReserved: '保留所有權利。',
    privacyPolicy: '隱私政策',
    termsOfService: '服務條款',
  },

  faq: {
    badge: '常見問題',
    heading: '常見問題',
    subheading: '關於這些工具的常見問題快速解答。',
    stillHaveQuestions: '還有問題嗎？我們很樂意幫助！',
    reachOut: '聯絡我們的團隊',
    questionHeader: '問題',
  },

  contactForm: {
    badge: '聯絡我們',
    title: '聯絡我們',
    subtitle: '我們很樂意聽到您的声音，請傳給我們一則訊息！',
    nameLabel: '姓名',
    namePlaceholder: '您的全名',
    emailLabel: '電子郵件',
    emailPlaceholder: 'you@example.com',
    subjectLabel: '主旨',
    subjectPlaceholder: '這是關於什麼的？',
    messageLabel: '訊息',
    messagePlaceholder: '在此輸入您的訊息…',
    errName: '姓名為必填項目',
    errEmail: '電子郵件為必填項目',
    errEmailInvalid: '請輸入有效的電子郵件',
    errSubject: '主旨為必填項目',
    errMessage: '訊息為必填項目',
    sending: '傳送中…',
    send: '發送訊息',
    successTitle: '訊息已發送!',
    successMsg: '感謝您的聯絡，我們將盡快回覆您。',
    sendAnother: '再發送一則',
    sendError: '發生錯誤，請重試。',
  },

  about: {
    label: '關於',
    heading: '為創作者而建，由創作者建立',
    subheading: '我們相信強大的圖片工具應該是免費的、快速的，對每個人都可以訪問的。',
    missionTitle: '我們的使命',
    missionText: 'photremium.com 的創建源於一個簡單的目標：提供網路上最直觀、最快速、最私密的圖片編輯體驗。',
    privacyTitle: '隱私優先',
    privacyText: '我們不會上傳、存儲或遠端處理您的圖片。一切都留在您的設備上。',
    techTitle: '現代技術',
    techText: '使用最先進的網路技術構建，包括 WebAssembly、Canvas API 和現代 React。',
    communityTitle: '社群驅動',
    communityText: '每個功能都受到真實用戶反饋的啟發。',
    globalTitle: '全球覆蓋',
    globalText: '被來自 120 多個國家的創作者使用。',
  },

  seo: {
    homeTitle: 'photremium.com — 免費線上圖片轉換器、壓縮器和編輯器',
    homeDesc: '免費線上轉換、壓縮、調整大小、裁剪和編輯圖片。',
    homeKeywords: '圖片轉換器, 圖片壓縮器, 調整圖片大小, 裁剪圖片, 照片編輯器',
    aboutTitle: '關於 photremium.com — 我們的使命',
    aboutDesc: '了解 photremium.com，受數百萬人信賴的免費線上圖片工具包。',
    aboutKeywords: 'photremium.com 關於, 圖片工具, 免費圖片編輯器',
  },

      privacyPolicyPage: {
    seo: {
      title: '隱私權政策 — Photremium |無伺服器上傳，零資料存儲',
      description: 'Photremium 的隱私權政策解釋了我們如何保護您的隱私。所有圖像處理 100% 在您的瀏覽器中進行 — 不會將文件上傳到任何伺服器，不會收集個人數據，也不會進行追蹤。',
      ogTitle: '隱私權政策 — Photremium |無需上傳，零存儲',
      ogDescription: '您的文件保留在您的裝置上。 Photremium 在您的瀏覽器中本地處理所有圖像，無需與伺服器聯繫，不儲存數據，也不進行追蹤。',
      twitterTitle: '隱私權政策 — Photremium',
      twitterDescription: '100% 基於瀏覽器的圖像工具。沒有上傳，沒有存儲，沒有追蹤。請閱讀我們完整的隱私權政策。',
      schemaName: '隱私權政策 - Photremium',
      schemaDescription: 'Photremium 隱私權政策 - 無伺服器上傳、無資料儲存、100% 瀏覽器內影像處理。'
    },
    hero: {
      badge: '隱私權政策',
      titlePrefix: '您的隱私就是我們的',
      titleHighlight: '最優先',
      subPrefix: 'photremium.com 的建立是基於一個簡單的原則 —',
      subStrong: '您的文件永遠不會離開您的設備',
      subSuffix: '網站上的每個圖像工具都完全在您的瀏覽器內運作。沒有上傳。沒有雲。沒有妥協。',
      effectiveLabel: '有效的',
      lastUpdatedLabel: '最後更新',
      worldwideLabel: '適用於全球'
    },
    trustCards: [
      {
        title: '無伺服器上傳',
        desc: '您的文件永遠不會離開您的裝置。所有處理都是 100% 在瀏覽器內進行。'
      },
      {
        title: '零數據存儲',
        desc: '我們不會儲存任何有關您、您的圖像或您的活動的資訊。'
      },
      {
        title: '無追蹤',
        desc: '沒有行為跟踪，沒有指紋識別，沒有分析。'
      },
      {
        title: 'GDPR 友善',
        desc: '從頭開始設計就尊重全球隱私法規。'
      }
    ],
    contentsTitle: '內容',
    toc: {
      overview: '概述',
      'no-upload': '無伺服器處理',
      'data-collect': '我們收集的數據',
      cookies: 'Cookie 和儲存',
      'third-party': '第三方服務',
      analytics: '分析',
      children: '兒童隱私',
      rights: '您的權利',
      security: '安全',
      changes: '政策變化',
      contact: '聯絡我們'
    },
    sections: {
      overview: {
        title: '1. 概述',
        subtitle: '該政策涵蓋哪些內容',
        p1Prefix: '本隱私權政策描述如何',
        p1Middle: '（「我們」、「我們」或「我們的」）處理 - 或者更準確地說，',
        p1Italic: '不處理',
        p1Suffix: '當您使用我們的免費線上圖像工具時您的個人訊息',
        p2: '與將檔案傳送到遠端伺服器進行處理的傳統 Web 應用程式不同，photremium.com 使用現代瀏覽器 API（Canvas API、WebAssembly、WebWorkers）在您的裝置上本地執行每個操作。結果：沒有資料傳輸、沒有儲存、沒有風險。',
        calloutLabel: '簡單的英文總結：',
        calloutText: '我們看不到您的圖像，我們也不想看到，而且我們的技術經過專門設計，因此我們永遠看不到。'
      },
      noUpload: {
        title: '2. 永遠沒有伺服器處理',
        subtitle: '我們的工具實際上是如何運作的',
        introPrefix: 'photremium.com 上的每個工具（影像轉換器、壓縮器、縮放器、背景移除器、臉部模糊、浮水印、裁剪和二維碼工具）都會處理您的文件',
        introStrong: '100% 在您的網頁瀏覽器中',
        introSuffix: '使用客戶端 JavaScript 和 WebAssembly。',
        points: [
          {
            label: '不會發生任何文件上傳。',
            text: '當您選擇一個檔案時，瀏覽器的檔案 API 會讀取該檔案並在記憶體中處理 - 它永遠不會透過網路發送。'
          },
          {
            label: '沒有伺服器接收您的圖像。',
            text: '我們的 CDN 僅提供執行應用程式所需的 HTML、CSS 和 JavaScript 資源，而不是您的檔案。'
          },
          {
            label: '沒有臨時存儲。',
            text: '處理後的結果僅存在於您的瀏覽器記憶體中，並在您關閉或離開頁面時釋放。'
          },
          {
            label: '離線工作。',
            text: '大多數工具在初始頁面加載後無需互聯網連接即可繼續運行 - 進一步證明不涉及伺服器。'
          }
        ],
        callout: '您可以自行驗證這一點：在開發者工具中開啟瀏覽器的「網路」標籤，選擇一個影像，並確認沒有檔案資料傳輸到任何外部伺服器。'
      },
      dataCollect: {
        title: '3. 我們收集（和不收集）的數據',
        subtitle: '數據實踐完全透明',
        headers: {
          type: '資料類型',
          collected: '集？',
          whereWhy: '地點/原因'
        },
        rows: [
          {
            type: '您的圖像/文件',
            badge: '絕不',
            variant: '綠色的',
            showX: true,
            whereWhy: '完全在您的瀏覽器中處理 - 從未傳輸'
          },
          {
            type: '姓名/電子郵件地址',
            badge: '絕不',
            variant: '綠色的',
            showX: true,
            whereWhy: '使用任何工具無需帳戶或註冊'
          },
          {
            type: 'IP位址',
            badge: '最小',
            variant: '灰色的',
            showX: false,
            whereWhy: '標準 Web 伺服器日誌保留 <= 30 天，與身分無關'
          },
          {
            type: '瀏覽器/作業系統類型',
            badge: '最小',
            variant: '灰色的',
            showX: false,
            whereWhy: '由您的瀏覽器自動發送；僅用於相容性'
          },
          {
            type: '造訪頁面/點擊次數',
            badge: '聚合',
            variant: '藍色的',
            showX: false,
            whereWhy: '僅匿名分析（無個人識別）'
          },
          {
            type: '語言偏好',
            badge: '限本地',
            variant: '藍色的',
            showX: false,
            whereWhy: '儲存到您裝置上的 localStorage — 從未傳送給我們'
          },
          {
            type: '付款/財務數據',
            badge: '絕不',
            variant: '綠色的',
            showX: true,
            whereWhy: 'photremium.com 完全免費，無需付款'
          }
        ]
      },
      cookies: {
        title: '4. Cookie 和本地存儲',
        subtitle: '您的裝置上儲存的內容',
        intro: 'photremium.com 不使用廣告 cookie、跨網站追蹤 cookie 和第三方 cookie。我們使用的唯一瀏覽器儲存用於基本的網站功能。',
        points: [
          {
            label: '語言偏好',
            text: '儲存在 localStorage 中，以便網站在存取之間記住您的首選語言。從未發送到我們的伺服器。'
          },
          {
            label: '主題/使用者介面首選項',
            text: '如果您設定顯示首選項，它只會儲存在您的裝置本機。'
          },
          {
            label: '沒有會話 cookie。',
            text: 'photremium.com 沒有登入系統，因此不會寫入會話 ID cookie。'
          }
        ],
        callout: '您可以隨時透過瀏覽器設定（設定 -> 隱私權 -> 清除瀏覽資料 -> 快取資料和 cookie）清除所有 photremium.com 本機儲存。这样做不会影响您使用这些工具的能力。'
      },
      thirdParty: {
        title: '5. 第三方服務',
        subtitle: '我們使用的外部服務以及原因',
        intro: 'photremium.com 使用最少的一組受信任的第三方服務，嚴格確保基礎設施和效能。這些服務均不會接收您的影像或任何個人識別資訊。',
        headers: {
          service: '服務',
          purpose: '目的',
          dataShared: '數據共享',
          privacyPolicy: '隱私權政策'
        },
        rows: [
          {
            service: 'Cloudflare 頁面',
            purpose: '網站資產的託管和 CDN 交付',
            dataShared: 'IP 位址、HTTP 標頭（標準）',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: '字體棒',
            purpose: '從 CDN 載入的圖示字體',
            dataShared: 'IP 位址（僅限 CSS 請求）',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: '谷歌字體',
            purpose: '字體加載（如果適用）',
            dataShared: 'IP 位址（僅限字體請求）',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: '我們不會與廣告商、數據經紀人或上述基礎設施提供者以外的任何其他第三方共享您的資料。'
      },
      analytics: {
        title: '6. 分析',
        subtitle: '聚合、尊重隱私的使用數據',
        introPrefix: '為了了解哪些工具受歡迎以及如何改進網站，我們可能會收集',
        introStrong: '匯總、匿名',
        introSuffix: '使用統計數據，例如：',
        points: [
          '每個工具的頁面瀏覽量（無使用者識別）',
          '推薦來源（例如 Google 搜尋、直接連結）—無個人數據',
          '國家級地理資料（不是城市或精確位置）',
          '用於相容性分析的瀏覽器/裝置類型'
        ],
        calloutLabel: '沒有任何數據與您個人相關。',
        calloutText: '我們不使用 Google Analytics 或 Meta Pixel。我們使用的任何分析都是隱私優先的工具（例如 Plasible 或類似工具）。'
      },
      children: {
        title: '7. 兒童隱私',
        subtitle: 'COPPA 與兒童安全合規性',
        p1: 'photremium.com 不会故意收集 13 岁以下（欧盟 GDPR 规定为 16 岁）以下儿童的任何个人信息。由於我們不收集任何用戶的個人數據，因此年輕用戶無需做任何特別的事情 - 該網站對每個人來說都同樣安全。',
        p2Prefix: '如果您認為孩子以某種方式透過我們的聯絡表提交了個人訊息，請立即與我們聯繫：',
        p2Suffix: '我們將及時刪除。'
      },
      rights: {
        title: '8. 您的權利',
        subtitle: 'GDPR、CCPA 和全球隱私權',
        intro: '由於 photremium.com 不收集任何個人識別信息，因此大多數資料主體權利的適用性並不重要 - 沒有關於您的資料可供存取、更正或刪除。儘管如此，我們完全承認並尊重以下權利：',
        points: [
          {
            label: '訪問權',
            text: '您可以索取我們持有的任何有關您的資料的副本。 （除了匿名日誌之外，沒有其他任何內容。）'
          },
          {
            label: '修正權',
            text: '您可以要求更正不準確的個人資料。'
          },
          {
            label: '刪除權（「被遺忘權」）',
            text: '您可以要求刪除我們持有的任何個人資料（GDPR 第 17 條、CCPA）。'
          },
          {
            label: '反對/選擇退出的權利',
            text: '您可以使用瀏覽器級選擇退出或廣告攔截工具選擇退出任何未來的分析收集。'
          },
          {
            label: '數據可攜性的權利',
            text: '您的所有作品都會直接下載到您的裝置 - 無需匯出請求。'
          }
        ],
        callout: '這些權利適用於全球所有用戶，無論司法管轄區為何－我們採用最高標準 (GDPR) 作為基準。'
      },
      security: {
        title: '9. 安全',
        subtitle: '我們如何保護您的體驗',
        intro: '最安全的資料是從未被收集的資料。 photremium.com 用戶端架構意味著伺服器漏洞無法暴露您的文件，因為您的文件永遠不會在我們的伺服器上。其他安全措施包括：',
        points: [
          {
            label: 'HTTPS 強制執行',
            text: '您的瀏覽器和我們的 CDN 之間的所有流量均透過 TLS 1.2+ 和 HSTS 進行加密。'
          },
          {
            label: '內容安全策略 (CSP)',
            text: '嚴格的標頭可防止跨站點腳本編寫和內聯腳本注入。'
          },
          {
            label: '定期依賴審計',
            text: '我們定期審核和更新 npm 軟體包以修補已知漏洞。'
          }
        ],
        disclosurePrefix: '負責任的揭露',
        disclosureTextPrefix: '發現安全問題？給我們發電子郵件：',
        disclosureTextSuffix: '我們將在 48 小時內回覆。'
      },
      changes: {
        title: '10. 本政策的變更',
        subtitle: '我們如何處理政策更新',
        intro: '我們可能會不時更新本隱私權政策，以反映我們的做法、工具或法律要求的變更。當我們這樣做時：',
        points: [
          {
            label: '“最後更新”',
            text: '本頁頂部的日期將被修改。'
          },
          {
            label: '重大變化',
            text: '將透過主頁上的顯著通知進行傳達至少 30 天。'
          },
          {
            label: '以前的版本',
            text: '本政策的內容將存檔並根據要求提供。'
          }
        ],
        outro: '在更改發布後繼續使用 photremium.com 即表示接受更新後的政策。我們鼓勵您定期查看此頁面。'
      },
      contact: {
        title: '11. 聯絡方式和資料請求',
        subtitle: '聯絡我們了解隱私問題',
        p1Prefix: '對於與本隱私權政策相關的任何問題、疑慮或正式資料請求，請與我們聯絡。我們的目標是在以下範圍內回覆所有與隱私相關的詢問',
        p1Strong: '5個工作天'
      }
    },
    footer: {
      privacyQuestionsTitle: '隱私問題？',
      privacyQuestionsDesc: '將您的隱私問題、資料請求或疑慮發送給我們，我們將立即回覆。',
      versionHistoryTitle: '版本歷史',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: '新功能！',
    download: '下載',
    downloadAll: '全部下載',
    downloadAs: '下載格式：',
    zip: 'ZIP',
    separate: '分別',
    upload: '上傳',
    dragDrop: '將圖片拖放到此處或點擊瀏覽',
    remove: '移除',
    reset: '重設',
    apply: '套用',
    cancel: '取消',
    clear: '清除',
    close: '關閉',
    save: '儲存',
    processing: '處理中...',
    noFiles: '未選擇文件',
    selectFiles: '選擇文件',
    or: '或',
    browseFiles: '瀏覽文件',
    dropHere: '將圖片放到這裡',
    chooseFiles: '選擇文件',
    pasteHint: '您也可以貼上圖片',
    quality: '品質',
    width: '寬度',
    height: '高度',
    format: '格式',
    compression: '壓縮',
    preview: '預覽',
    original: '原始',
    result: '結果',
    before: '之前',
    after: '之後',
    startOver: '重新開始',
    startOverConfirm: '移除所有圖片並重新開始？',
    addMoreImages: '添加更多圖片',
    addImage: '添加圖片',
    images: '圖片',
    totalSize: '總大小',
    size: '大小',
    type: '類型',
    unsavedEdits: '您有未儲存的編輯。確定要離開此頁面嗎？',
    compareSlider: '比較滑桿',
    toggleToolsPanel: '切換工具面板',
    closePanel: '關閉面板',
    zoomIn: '放大',
    zoomOut: '縮小',
    fit: '適合',
    none: '無',
  },

  compressor: {
    seo: {
      uploadTitle: '圖片壓縮器 — 免費壓縮 JPG、PNG、SVG、GIF | photremium.com',
      uploadDesc: '免費線上壓縮 JPG、PNG、SVG 和 GIF 圖片。在保持品質的同時將文件大小縮小多達 80%。',
      uploadKeywords: '圖片壓縮器, jpg 壓縮, png 壓縮, 縮小圖片大小',
      workspaceTitle: '壓縮圖片中 — photremium.com 圖片壓縮器',
      workspaceDesc: '調整壓縮級別並下載優化後的圖片。',
      workspaceKeywords: '圖片壓縮, 圖片優化',
    },
    title: '圖片壓縮器',
    desc: '將 JPG、PNG 和 GIF 圖片壓縮多達 80%。快速且安全。',
    toCompress: '要壓縮',
    compressionForAll: '所有圖片的壓縮',
    summary: '摘要',
    originalSize: '原始大小',
    compressed: '已壓縮',
    saved: '已節省',
    compressionLabel: '壓縮：',
    compressing: '壓縮中…',
    compressDownload: '壓縮並下載',
    lowQualityWarning: '高壓縮可能會明顯降低影像清晰度。',
    blog: {
      tocTitle: '目錄',
      title: '圖片壓縮部落格',
      formatsIntro: '我們的工具支援所有圖片格式，因此您可以順暢壓縮任何圖片。完整格式清單如下：',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. 什麼是圖片壓縮器？',
          paragraphs: [
            '圖片壓縮器是一種軟體工具或線上服務，可在盡量維持視覺品質的前提下縮小圖片檔案大小。不過若壓縮過高，畫質可能明顯下降。',
          ],
          listTitle: '類型：',
          bullets: [
            '有損壓縮：透過移除部分圖片資料來降低檔案大小，畫質可能下降，但在較低壓縮下通常不易被肉眼察覺。',
            '無損壓縮：在不影響圖片視覺品質的情況下縮小檔案大小。',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. 為什麼選擇我們的工具？',
          bullets: [
            '我們的 AI 圖片壓縮工具可在各種裝置上順暢運作，提供最佳結果。',
            '您可以一鍵同時壓縮多張圖片（甚至 100+ 張）。',
            '不需要將圖片上傳到我們的伺服器，所有處理都在您的瀏覽器本機完成。',
            '我們的圖片壓縮工具永久免費，也可分享給朋友使用。',
            '您可以依需求自由選擇壓縮百分比。',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. 逐步指南',
          steps: [
            {
              heading: '1. 選擇要壓縮的圖片。',
              bullets: [
                '將圖片拖放到上傳區域。',
                '也可以複製圖片後使用 (Ctrl + V) 貼上到上傳區域。',
                '也支援點擊選擇按鈕，透過檔案總管挑選圖片。',
              ],
            },
            {
              heading: '2. 接著選擇壓縮百分比。',
              bullets: [
                '橫向滑桿可讓您舒適地選擇壓縮比例。建議依照以下區間以獲得更精準的結果。',
              ],
              table: {
                headers: ['壓縮百分比', '結果'],
                rows: [
                  ['1%  到  40%', '最佳品質'],
                  ['41%  到  60%', '一般品質（建議）'],
                  ['61%  到  100%', '較差品質'],
                ],
              },
            },
            {
              heading: '3. 檢查您節省的空間。',
              paragraphs: [
                '所有容量指標都會即時顯示。您可以清楚看到總共節省了多少空間，並依需求調整壓縮等級以取得理想檔案大小。',
              ],
            },
            {
              heading: '4. 透過切換按鈕選擇下載方式。',
              bullets: [
                'ZIP：當您壓縮多張圖片時會出現此選項。選擇後會將所有壓縮圖片打包成一個 ZIP 檔（大量圖片建議使用）。',
                '個別下載：選擇後將逐張下載，不會合併成單一 ZIP（適合較少圖片，少於 10 張）。',
              ],
            },
            {
              heading: '5. 壓縮並下載圖片。',
              paragraphs: [
                '按下此按鈕後，系統會依您選擇的下載方式自動下載所有壓縮後圖片。',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. 圖片壓縮的好處。',
          bullets: [
            '降低儲存成本：壓縮圖片可顯著減少檔案大小並節省儲存空間。',
            '載入更快：壓縮圖片可加快載入速度，提升網站或應用程式的使用體驗。',
            '解決 Gmail 附件限制：Gmail 附件上限為 25MB，壓縮後可傳送更多檔案。',
            '分享與傳輸更快：大檔案傳輸耗時較久，壓縮可節省時間與流量。',
            '簡報最佳化：未壓縮圖片會讓簡報檔案過大且卡頓，壓縮後可大幅縮小檔案大小。',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. 支援格式。',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: '圖片轉換器 — 免費轉換 PNG、JPG、WEBP、GIF、SVG | photremium.com',
      uploadDesc: '在 JPG、PNG、WEBP、GIF、SVG、TIFF 和 BMP 之間轉換圖片。免費線上圖片格式轉換器。',
      uploadKeywords: '圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',
      workspaceKeywords: '圖片轉換, 圖片格式轉換器',

      routeKeywords: {

        'png-to-jpg': 'png 要轉換 jpg, png to jpg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'jpg-to-png': 'jpg 要轉換 png, jpg to png, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'png-to-webp': 'png 要轉換 webp, png to webp, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'jpg-to-webp': 'jpg 要轉換 webp, jpg to webp, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'webp-to-jpg': 'webp 要轉換 jpg, webp to jpg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'webp-to-png': 'webp 要轉換 png, webp to png, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'gif-to-jpg': 'gif 要轉換 jpg, gif to jpg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'gif-to-png': 'gif 要轉換 png, gif to png, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'bmp-to-jpg': 'bmp 要轉換 jpg, bmp to jpg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'bmp-to-png': 'bmp 要轉換 png, bmp to png, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'svg-to-png': 'svg 要轉換 png, svg to png, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'svg-to-jpg': 'svg 要轉換 jpg, svg to jpg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'tiff-to-jpg': 'tiff 要轉換 jpg, tiff to jpg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'tiff-to-png': 'tiff 要轉換 png, tiff to png, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'jpg-to-gif': 'jpg 要轉換 gif, jpg to gif, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'png-to-gif': 'png 要轉換 gif, png to gif, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'jpg-to-bmp': 'jpg 要轉換 bmp, jpg to bmp, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'png-to-bmp': 'png 要轉換 bmp, png to bmp, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'webp-to-gif': 'webp 要轉換 gif, webp to gif, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'jpg-to-ico': 'jpg 要轉換 ico, jpg to ico, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'png-to-ico': 'png 要轉換 ico, png to ico, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'jpg-to-svg': 'jpg 要轉換 svg, jpg to svg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'png-to-svg': 'png 要轉換 svg, png to svg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'webp-to-svg': 'webp 要轉換 svg, webp to svg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'gif-to-svg': 'gif 要轉換 svg, gif to svg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'bmp-to-svg': 'bmp 要轉換 svg, bmp to svg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

        'tiff-to-svg': 'tiff 要轉換 svg, tiff to svg, 圖片轉換器, png 轉 jpg, jpg 轉 png, webp 轉換器',

      },
    },
    title: '圖片轉換器',
    desc: '在 JPG、PNG、WEBP、GIF、SVG、TIFF 和 BMP 之間轉換圖片。批量轉換多個文件。',
    toConvert: '要轉換',
    convertSettings: '轉換設定',
    detected: '已偵測',
    convertTo: '轉換為',
    converting: '轉換中…',
    convertToFormat: '轉換為 {format}',
    popularConversions: '熱門轉換',
    convertingTo: '正在轉換為',
    all: '全部',
  },

  resizer: {
    seo: {
      uploadTitle: '調整圖片大小 — 免費線上調整 JPG 和 PNG 大小 | photremium.com',
      uploadDesc: '免費線上按像素或百分比調整圖片大小。',
      uploadKeywords: '調整圖片大小, 圖片調整器, 調整 jpg 大小, 調整 png 大小',
      workspaceTitle: '調整圖片大小中 — photremium.com',
      workspaceDesc: '免費線上調整圖片大小。',
      workspaceKeywords: '調整圖片大小, 調整器',
    },
    title: '調整圖片大小',
    desc: '以像素、百分比、公分或英寸定義大小並立即調整。',
    toResize: '要調整大小',
    resizeSettings: '調整大小設定',
    resizeBy: '調整大小依據：',
    byPixels: '像素',
    byPercentage: '百分比',
    byCentimeters: '公分',
    byInches: '英寸',
    advanced: '進階',
    lockAspect: '鎖定比例',
    unlockAspect: '解鎖比例',
    dontEnlarge: '如果原始圖片更小則不放大',
    resizing: '調整大小中…',
    resizeDownload: '調整大小並下載',
    blog: {
      tocTitle: '目錄',
      title: '圖片尺寸調整部落格',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. 為什麼要使用圖片尺寸調整工具？',
          paragraphs: [
            '圖片尺寸調整工具是一種用來改變圖片尺寸（寬高）的工具/軟體。您可以調整高度、寬度或兩者，以取得需要的大小。對於有圖片上傳/發佈尺寸限制的社群平台特別實用。',
          ],
          listTitle: '例如：',
          bullets: [
            'Instagram 貼文：1080 x 1080px（方形）',
            'Facebook 貼文：1200 x 630px',
            'X（Twitter）貼文：1200 x 675px',
            'Instagram 限時動態：1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. 為什麼選擇我們的圖片尺寸調整工具？',
          paragraphs: [
            '我們的 AI 圖片尺寸調整工具可讓您以高精準度、超快速調整圖片大小。工具可在任何裝置上順暢運作，且不需要安裝應用程式。所有功能都可直接在瀏覽器中線上使用。',
          ],
          bullets: [
            '您可以同時調整多張圖片（甚至 100+）。若裝置效能夠高，400–500 張也可在幾秒內完成處理。',
            '所有處理都在本機瀏覽器完成，不需上傳到我們的伺服器，圖片不會離開您的裝置。',
            '支援多種尺寸單位。',
            '只需勾選一個選項即可在調整後維持原始長寬比。',
            '多張圖片可選擇逐張下載或 ZIP 打包下載。',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. 逐步指南',
          steps: [
            {
              heading: '首先，選擇要調整大小的圖片（可單張或多張）。支援多種選取方式。',
              bullets: [
                '將圖片拖曳到上傳區塊。',
                '也可使用 “Ctrl + V” 快捷鍵貼上圖片。',
                '或按 “Choose Files” 從檔案總管選擇。',
              ],
            },
            {
              heading: '接著選擇尺寸單位。目前支援：',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: '選擇單位後，設定寬度與高度。若需要可勾選維持長寬比。',
            },
            {
              heading: '若不希望放大超過原圖，請啟用 “Don’t enlarge if original is smaller”。',
            },
            {
              heading: '接著選擇下載方式。',
              bullets: [
                '若要把所有結果打包成一個 zip 檔，請選 ZIP。',
                '若要每張圖片分開下載，請選 “separate”。',
              ],
            },
            {
              heading: '最後按下 “Resize & Download”，即可依所選方式下載。',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. 圖片尺寸調整工具的優點：最大優點是可讓圖片在網頁與社群貼文中正確呈現。',
          tocLabel: '4. 圖片尺寸調整工具的優點',
          bullets: [
            '提升 UX：正確的圖片尺寸與擺放可明顯改善使用者體驗。',
            '社群平台相容：許多平台有尺寸限制，工具可協助快速符合規範。',
            '支援響應式設計：開發者通常需要為不同裝置準備不同尺寸圖片。',
            '更好的選擇：比起強行拉伸或過度裁切造成比例失真，尺寸調整通常更合理。',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. 支援格式：我們的圖片尺寸調整工具支援幾乎所有圖片格式。支援清單如下：',
          tocLabel: '5. 支援格式',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: '裁剪圖片 — 免費線上裁剪 JPG、PNG 和 GIF | photremium.com',
      uploadDesc: '免費輕鬆線上裁剪 JPG、PNG 和 GIF 圖片。',
      uploadKeywords: '裁剪圖片, 圖片裁剪器, 裁剪 jpg, 裁剪 png',
      workspaceTitle: '裁剪圖片中 — photremium.com',
      workspaceDesc: '免費線上裁剪圖片。',
      workspaceKeywords: '裁剪圖片, 裁剪器',
    },
    title: '裁剪圖片',
    desc: '使用視覺化編輯器裁剪 JPG、PNG 和 GIF。預設比例或自由形式裁剪。',
    toCrop: '要裁剪',
    cropSettings: '裁剪設定',
    widthPx: '寬度 (px)',
    heightPx: '高度 (px)',
    positionX: '位置 X (px)',
    positionY: '位置 Y (px)',
    cropTemplate: '裁剪模板',
    landscape: '橫向',
    portrait: '縱向',
    square: '正方形',
    freeform: '自由形式',
    cropping: '裁剪中…',
    cropDownload: '裁剪並下載',
    cropDownloadAll: '裁剪並全部下載',
    saveNext: '儲存並下一個',
    croppedNofTotal: '已裁剪 {total} 個中的 {n} 個。',
    downloadN: '下載 {n} 個',
    blog: {
      tocTitle: '目錄',
      title: '圖片裁剪部落格',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. 為什麼要使用圖片裁剪工具？',
          paragraphs: [
            '圖片裁剪工具是一種可將圖片裁成所需形狀的軟體工具。它廣泛用於保留圖片中需要的部分，並移除外圍不需要的區域，以應對各種用途。此工具提供可調整的裁剪框，您可將其移到想裁剪的位置。',
          ],
          listTitle: '例如：',
          bullets: [
            '從團體照中裁出自己。',
            '從清單中裁出您的名字。',
            '從全螢幕截圖中裁出進度條。',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. 為什麼選擇我們的圖片裁剪工具？',
          paragraphs: [
            '我們的圖片裁剪工具可讓您精準且快速地裁剪圖片。您只需把裁剪框調整到想裁切的位置與大小即可。選圖時幾乎支援所有圖片格式。',
          ],
          bullets: [
            '您可裁剪裝置可支援的任意數量圖片。若裝置效能夠高，甚至可一次裁剪 100+ 張圖片且不卡頓。',
            '您的圖片會在本機瀏覽器內處理。無需上傳到我們的伺服器，因此圖片不會離開您的裝置。您可安心裁剪私人圖片。',
            '許多工具會顯示圖片格式無效錯誤。我們的圖片裁剪工具透過支援幾乎所有格式來解決此問題。',
            '若您一次裁剪多張圖片，我們的工具可依偏好提供 ZIP 打包下載或逐張下載。',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. 逐步指南',
          steps: [
            {
              heading: '1. 首先，選擇要裁剪的圖片。我們的圖片裁剪工具也支援一次選擇多張圖片。',
              bullets: [
                '將圖片拖曳到投放框即可開始裁剪。',
                '您也可點擊裁剪框中的 choose files 按鈕，從檔案總管選擇圖片。',
                '也支援 Ctrl + V 快捷鍵，將圖片貼到投放框。',
              ],
            },
            {
              heading: '2. 接著，在圖片上調整裁剪框大小與位置。',
            },
            {
              heading: '3. 您也可手動輸入高度、寬度、水平位置與垂直位置來調整裁剪框。',
            },
            {
              heading: '4. 也可使用以下現成模板：',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. 然後請選擇其中一種下載方式。',
              bullets: [
                'ZIP：若您同時裁剪多張圖片並想一次下載成單一檔案，請選此選項。',
                'Separate：若您想逐張下載裁剪後圖片，請在切換按鈕選擇此選項。',
              ],
            },
            {
              heading: '6. 最後點擊 Crop & Download 按鈕，即可依預設尺寸下載所有裁剪後圖片。',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. 圖片裁剪的優點：圖片裁剪工具在數位世界中帶來多項好處，以下為部分說明：',
          tocLabel: '4. 圖片裁剪的優點',
          bullets: [
            '讓圖片符合框架：圖片裁剪工具可幫助您將圖片正確放入框架，框架可能位於網頁或社群平台。',
            '提升 UX：正確的圖片擺放可提升使用者體驗，因此圖片裁剪有助於大幅改善 UX。',
            '移除不需要邊界：您可去除圖片中不必要的邊緣，讓圖片更精緻。',
            '分離目標物件：您也可從團體照中分離出自己。',
            '節省儲存空間：裁剪會移除原圖多餘區域，只保留需要部分，因而節省儲存。',
            '最佳化簡報：若 10 張未裁剪圖片的普通簡報約 30MB，使用裁剪圖片後同內容可能約 10MB。',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. 支援格式：',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: '線上照片編輯器 — 免費添加文字、效果和邊框 | photremium.com',
      desc: '免費線上編輯照片 — 添加文字、效果、邊框和貼圖。在瀏覽器中執行。',
      keywords: '照片編輯器, 線上照片編輯器, 免費線上照片編輯',
    },
    title: '照片編輯器',
    desc: '用文字、效果、邊框和貼圖裝飾您的照片。',
    toEdit: '要編輯',
    textTypography: '文字與排版',
    textTypographyDesc: '使用各種字型、顏色、陰影和位置選項添加文字。',
    filtersEffects: '濾鏡與效果',
    filtersEffectsDesc: '套用專業濾鏡並調整亮度、對比度和飽和度。',
    framesStickers: '邊框與貼圖',
    framesStickersDesc: '選擇美麗的邊框和有趣的貼圖來增強您的圖片。',
  },

  removeBg: {
    seo: {
      uploadTitle: '免費移除圖片背景 | photremium.com',
      uploadDesc: '以高精度快速移除圖片背景。免費線上背景移除器。',
      uploadKeywords: '移除背景, 背景移除器, 移除圖片背景, 透明背景',
      workspaceTitle: '移除背景中 — photremium.com',
      workspaceDesc: '免費線上移除圖片背景。',
      workspaceKeywords: '移除背景, 透明背景',
    },
    title: '移除背景',
    desc: '通過高級邊緣偵測即時移除圖片背景。100% 免費，在瀏覽器中執行。',
    toRemoveBg: '要移除背景',
    backgroundRemover: '背景移除器',
    processingProgress: '處理進度',
    processingNImages: '正在處理 {n} 張圖片…',
    allNProcessed: '所有 {n} 張圖片已處理完成！',
    nOfTotalDone: '{n} / {total} 完成',
    fileName: '文件名',
    dimensions: '尺寸',
    status: '狀態',
    statusDone: '✓ 完成',
    statusProcessing: '⏳ 處理中',
    statusError: '✗ 錯誤',
    statusPending: '⏸ 待處理',
    badgeDone: '完成',
    badgeProcessing: '處理中…',
    badgeError: '錯誤',
    removingBg: '移除背景中…',
    retry: '重試',
    downloading: '下載中…',
    nextImage: '下一張圖片',
  },

  watermark: {
    seo: {
      uploadTitle: '圖片浮水印 — 免費添加文字和圖示浮水印 | photremium.com',
      uploadDesc: '在幾秒鐘內為照片添加文字或圖片浮水印。免費、快速。',
      uploadKeywords: '浮水印圖片, 添加浮水印, 文字浮水印',
      workspaceTitle: '圖片浮水印 — photremium.com',
      workspaceDesc: '免費線上為圖片添加浮水印。',
      workspaceKeywords: '浮水印圖片, 添加浮水印',
    },
    title: '浮水印圖片',
    desc: '為圖片添加文字或圖示浮水印。自訂字型、不透明度、大小和位置。',
    toWatermark: '要添加浮水印',
    watermarkTools: '浮水印工具',
    addText: '添加文字',
    addImage: '添加圖片',
    layersN: '圖層 ({n})',
    noLayers: '尚未添加任何圖層',
    textLayer: '文字圖層',
    imageLayer: '圖片圖層',
    watermarkDownloadAll: '添加浮水印並全部下載',
    watermarkDownload: '添加浮水印並下載',
    nextImage: '下一張圖片',    selectToEdit: '選擇任意圖片或文字開始編輯',    bold: '粗體',
    italic: '斜體',
    underline: '底線',
    bgColor: '背景顏色',
    textColor: '文字顏色',
    alignLeft: '靠左對齊',
    alignCenter: '居中對齊',
    alignRight: '靠右對齊',
    opacity: '不透明度',
    stroke: '描邊',
    strokeWidth: '描邊寬度',
    strokeColor: '描邊顏色',
    tileRepeat: '平鋪/重複',
    tilePattern: '平鋪模式',
    spacing: '間距',
    snapToCenter: '對齊到中心',
    duplicate: '複製',
    delete: '刪除',
    flipHorizontal: '水平翻轉',
    flipVertical: '垂直翻轉',
    rotateLeft: '向左旋轉',
    rotateRight: '向右旋轉',
    cornerRadius: '圓角半徑',
    borderStroke: '邊框/描邊',
    borderWidth: '邊框寬度',
    color: '顏色',
    style: '樣式',
    hide: '隱藏',
    show: '顯示',
    lock: '鎖定',
    unlock: '解鎖',
    solid: '實線',
    dashed: '虛線',
    dotted: '點線',
    double: '雙線',
    tileSingle: '單個',
    tile2x2: '2×2 網格',
    tile3x3: '3×3 網格',
    removeAllConfirm: '移除所有圖片和浮水印？',
    dimMismatch: '上傳的圖片尺寸不同。為獲得最佳結果，請上傳相同解析度的圖片。',
    clearBackground: '清除背景',
    typeHere: '在此輸入...',
    linkCorners: '連結角落',
    separateCorners: '分離角落',
    blog: {
      tocTitle: '目錄',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: '浮水印工具概覽',
          title: '如何在線為圖片添加浮水印 — Photremium 浮水印工具完整指南',
          paragraphs: [
            '你剛完成一張漂亮的照片編輯。也許是你的商店產品照、客戶拍攝的人像，或你花了數小時打磨的數位藝術作品。現在每位創作者終究都會面對的問題來了：在分享之前，如何保護它？',
            '多數專業人士的答案是：浮水印 — 而且理由充足。位置恰當的浮水印就像作品上的永久簽名，讓你的作品可追溯、有品牌識別，也更難被盜用。',
            '大多數人遇到的問題是：現有線上工具要嘛太笨重、要嘛被訂閱鎖住，或是產生的浮水印太厚重，直接毀掉圖片。',
            'Photremium 的浮水印工具正是為了解決這些問題而打造。它是完全基於瀏覽器的浮水印工作區，免費、免帳號，直接在瀏覽器內運作，從不把檔案上傳到伺服器。一切都在本地完成、速度很快，而且提供的創意控制力可媲美桌面軟體。本指南會帶你了解它如何運作、適合誰使用，以及如何每次都得到最佳結果。',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: '什麼是浮水印',
          title: '浮水印是什麼？為什麼重要？',
          paragraphs: [
            '在深入工具之前，先了解浮水印的作用，以及為什麼這麼多攝影師、設計師與內容創作者都認為它不可或缺。',
            '浮水印是疊加在圖片上的可見內容 — 通常是文字、標誌或版權符號 — 用來識別內容的創作者或所有者。與中繼資料不同（中繼資料藏在檔案裡，幾秒內就能移除），浮水印是視覺化地嵌入圖片。你無法透過右鍵快速移除它而不明顯降低畫質。',
          ],
          subSections: [
            {
              title: '創作者為什麼使用浮水印',
              paragraphs: [
                '為圖片加浮水印的實際原因，主要可歸結為三個核心點。',
              ],
              bullets: [
                '所有權識別。當你的作品在社群平台、Pinterest 看板或部落格文章中被分享時，原始署名常常消失。浮水印可確保你的名字或品牌隨圖像一同流傳。',
                '防盜威懾。多數臨時性盜圖者會選最容易的路徑。一個專業、位置得當且略帶透明的浮水印會傳達明確訊號：這張圖片屬於在乎其作品的人。',
                '客戶作品保護。攝影師在客戶付款前提供預覽時，常使用浮水印防止對方在未結清費用前使用。低調的浮水印可以達到目的，且不影響評估。',
              ],
            },
            {
              title: '哪些人應該為圖片加浮水印',
              paragraphs: [
                '如果你屬於以下任一類型，在線分享前加浮水印不是選項 — 而是必要：',
              ],
              bullets: [
                '與客戶分享作品集的自由攝影師',
                '發布作品樣本的平面設計師',
                '授權前展示產品照片的電商賣家',
                '在社群平台分享作品的數位藝術家',
                '圖片經常被轉載的部落客與內容創作者',
                '建立可辨識品牌的圖庫貢獻者',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: '工作區面板',
          title: 'Photremium 浮水印工具內部：為真實工作流程打造的三面板工作區',
          paragraphs: [
            'Photremium 浮水印工具與一般線上浮水印工具的最大差異，在於其工作區設計。它不是簡單的「輸入文字、選位置、完成」，而是提供三面板布局，呼應專業設計軟體 — 但完全在瀏覽器中運行，零安裝。',
          ],
          subSections: [
            {
              title: '左側畫布面板',
              paragraphs: [
                '畫布面板占據螢幕最大區域，實時顯示加上浮水印後的畫面。你做的每一個調整 — 改透明度、移動文字層、縮放標誌 — 都會即時反映在畫布上。沒有「預覽」按鈕，所見即所得。',
                '畫布也包含內建縮放工具列，方便你放大精準對齊或縮小看全貌。Zoom-to-fit 會依螢幕大小自動計算最佳初始縮放，讓高解析度圖片也能舒適編輯。當你將圖層拖到水平或垂直中心附近時，會出現對齊導線，浮水印會自動吸附到中心，精準度媲美 Photoshop。',
              ],
            },
            {
              title: '右側設定面板',
              paragraphs: [
                '右側面板是控制中心。你可在此管理浮水印圖層、調整外觀並啟動最終匯出。桌面端固定在右側；手機端會以底部面板形式滑出 — 由浮動齒輪按鈕觸發 — 不會遮住畫布。',
                '右側面板內有圖層管理器，列出所有浮水印元素。每個圖層項目顯示類型（文字或圖片）、名稱或內容，並提供三個快速按鈕：可見性切換（眼睛圖示）、鎖定位置、刪除。',
              ],
            },
            {
              title: '左側預覽列（多圖模式）',
              paragraphs: [
                '當你同時處理多張圖片 — 例如產品照批次或完整人像拍攝 — 螢幕左側會出現垂直縮圖列。這是圖片佇列，顯示每個已載入檔案的縮圖。點擊任何縮圖即可立即切換畫布到該圖片，讓你能檢查不同構圖下的浮水印效果而不會失去圖層設定。',
                '縮圖列也會顯示每個檔案大小（KB 或 MB）與格式（JPG、PNG、WEBP），讓你一眼就知道正在處理的檔案。',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: '步驟指南',
          title: '步驟指南：如何在 Photremium 添加浮水印',
          paragraphs: [
            '本教學直接基於工具實際運作方式 — 從拖放上傳系統到在下載前將浮水印永久寫入圖片的畫布渲染引擎。',
          ],
          steps: [
            {
              heading: '步驟 1 — 上傳你的圖片',
              paragraphsBefore: [
                '前往 photremium.com/watermark-image。你會看到上傳畫面，中央是乾淨的拖放區。',
                '你有三種方式把圖片放進工具：',
              ],
              bullets: [
                'Drag and drop. 從桌面拖曳一張或多張圖片到投放區。工具支援 JPEG、PNG、WEBP 等標準格式。拖曳檔案進工作區時，整個區域會出現紫色框線與 “Drop images to add for watermarking” 提示，表示已偵測到拖放。',
                'Click to browse. 點擊投放區內的 “Choose Files” 按鈕開啟檔案選擇器。可用 Ctrl+Click（Windows）或 Cmd+Click（Mac）一次選多張。',
                'Paste from clipboard. 如果你已將圖片複製到剪貼簿（螢幕截圖、其他應用或瀏覽器），在水印頁按 Ctrl+V（Mac 為 Cmd+V）即可直接載入到工作區。即使已載入多張圖片也同樣有效。',
              ],
              paragraphsAfter: [
                '第一張圖片載入後，工作區會從上傳畫面切換為完整三面板編輯器，畫布會以自動計算的 fit-to-screen 縮放顯示圖片。',
              ],
            },
            {
              heading: '步驟 2 — 新增文字浮水印圖層',
              paragraphsBefore: [
                '在右側面板點擊紫色 “Add Text” 按鈕。畫布上會出現新的文字圖層，預設文字為 “Type here...” 且已選取。',
                '你可以立刻輸入。文字會以白色 Arial 的預設大小即時渲染在畫布上。當文字圖層被選取時，上方工具列會出現，你可以調整文字所有細節：',
              ],
              bullets: [
                'Font family — 從 12 種內建字體中選擇，包括 Arial、Georgia、Impact、Brush Script MT、Comic Sans MS 等',
                'Font size — 直接輸入像素值或使用增減控制',
                'Bold, italic, underline — 任意組合這些樣式',
                'Text color — 點擊色塊開啟選色器，選擇任何十六進位色碼',
                'Background color — 在文字背後加上色塊，形成標籤或徽章樣式',
                'Stroke (outline) — 設定描邊寬度與顏色，讓文字在明暗背景都清晰可讀',
                'Opacity — 從 0%（不可見）到 100%（完全可見）調整；多數浮水印落在 30%–60%',
                'Alignment — 在邊界框中左對齊、置中或右對齊',
                'Rotation — 任意角度旋轉，並提供 0°、90°、180°、270° 的磁吸對齊',
              ],
              paragraphsAfter: [
                '要移動文字，點擊並拖曳即可。若需像素級精準定位，使用鍵盤方向鍵（按住 Shift 為 10 像素步進）。要調整文字框大小，拖曳周圍 8 個調整點（四角與四邊）。',
              ],
            },
            {
              heading: '步驟 3 — 新增圖片（標誌）浮水印圖層',
              paragraphsBefore: [
                '如果你想用標誌、簽名或圖片作為浮水印（取代或搭配文字），點擊右側面板的藍色 “Add Image” 按鈕。檔案選擇器會開啟，讓你選擇浮水印圖片。',
                '工具會自動將浮水印圖片縮放至畫布寬度約 30%，保持原始比例並置中。接著你可以拖曳到任意位置，用角落把手縮放（比例鎖定），或用上方旋轉把手旋轉。',
                '圖片類型的浮水印圖層在右側面板會顯示額外控制項：',
              ],
              bullets: [
                'Opacity — 與文字圖層相同，適合透明 PNG 標誌',
                'Flip horizontal / Flip vertical — 需要時可鏡像翻轉浮水印',
                'Border width, border color, and border style — 為標誌浮水印添加可見邊框',
                'Border radius — 圓角處理，可統一或分別控制各角',
                'Rotation — 與文字圖層相同的平滑旋轉行為',
              ],
            },
            {
              heading: '步驟 4 — 設定平鋪（可選）',
              paragraphsBefore: [
                '工具的一個強大功能是平鋪 — 可以在整張圖片上重複水印形成網格。當你想讓圖片無法被再利用，而不只是標記時，這特別有用。',
                '選取圖層後，在工具列中找到 tile 選項，可設為：',
              ],
              bullets: [
                'None — 單一放置（預設）',
                'Grid 2×2 — 以 2 欄 2 列重複浮水印',
                'Grid 3×3 — 以 3×3 網格重複，覆蓋更密集',
              ],
              paragraphsAfter: [
                '你也可以調整平鋪間距，控制每次重複之間的距離。畫布會顯示所有平鋪副本的幽靈預覽，方便下載前確認覆蓋範圍。',
              ],
            },
            {
              heading: '步驟 5 — 使用圖層管理器處理多個浮水印',
              paragraphsBefore: [
                '你可以添加任意數量的圖層 — 混合文字與圖片浮水印。右側面板的圖層管理器會列出全部。你可以：',
              ],
              bullets: [
                '用眼睛圖示顯示/隱藏單一圖層 — 方便在不同浮水印版本間切換而不需刪除',
                '鎖定圖層以避免在調整其他圖層時誤移',
                '永久刪除圖層',
              ],
              paragraphsAfter: [
                '點擊列表中的任何圖層項目，該圖層會在畫布上被選取，方便你快速切換。',
              ],
            },
            {
              heading: '步驟 6 — 在多張圖片之間切換',
              paragraphsBefore: [
                '如果你上傳了多張圖片，使用左側縮圖列切換當前畫布圖片。你設定的浮水印圖層會通用套用 — 匯出時會渲染到批次中的每張圖片。',
                '工具也會檢查解析度一致性。若圖片尺寸差異明顯（寬或高差超過 5%），會顯示警告，提醒浮水印位置可能因尺寸差異而不同。引擎使用比例重定位演算法處理：以參考圖的尺寸百分比計算水印位置，再套用到其他圖片，確保不同解析度下也保持一致視覺意圖。',
              ],
            },
            {
              heading: '步驟 7 — 設定下載偏好',
              paragraphsBefore: [
                '單張圖片時，點擊畫布下方的 “Download” 按鈕即可直接保存水印圖片。檔名會自動在原檔名後加上 “-watermarked”。JPEG 以 0.95 品質輸出 — 在一般觀看尺寸下幾乎與原圖無差異。PNG 則以無損 PNG 輸出。',
                '批次處理（多張圖片）時，右側面板提供兩種下載模式：',
              ],
              bullets: [
                'ZIP file — 將所有水印圖片打包成一個 ZIP，一鍵下載。工具會動態載入 JSZip 進行壓縮。',
                'Separate files — 每張圖片獨立下載，下載之間會有短暫間隔以避免瀏覽器節流。',
              ],
            },
            {
              heading: '步驟 8 — 下載並驗證',
              paragraphsBefore: [
                '點擊下載按鈕（或批次的 “Watermark & Download All” 按鈕）後，工具會在隱藏的 HTML5 canvas 上以原生解析度渲染每張圖片 — 不是螢幕上的縮放預覽尺寸。這表示輸出圖片保有 100% 原始像素尺寸，浮水印也會以正確比例繪製。打開下載檔並放大檢查，確認浮水印的位置與品質符合預期。',
                '若有不理想之處，回到工作區 — 你的圖層仍在 — 調整後再下載即可。',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: '專業建議',
          title: '獲得最佳結果的專業建議',
          bullets: [
            '使用半透明 PNG 標誌更顯專業。透明背景、40–50% 不透明度的標誌浮水印比實心文字更精緻。使用前請從設計工具以帶 alpha 透明的 PNG 匯出標誌。',
            '將浮水印放在裁切會降低價值的位置。右下角是最常見的位置 — 也是最容易被裁切的。想要更強保護，可把浮水印放在影像重要區域，例如臉部、產品細節或視覺焦點。對角平鋪更難移除且不易破壞圖片。',
            '處理多圖層時使用鎖定功能。當主浮水印位置滿意後先鎖定，再添加其他圖層，可避免意外移動。',
            '在明暗區域都測試。白色浮水印在亮天空上看不見，但在陰影中很清楚。加入細描邊或淡背景色可確保可讀性。',
            '鍵盤快捷鍵能省時。方向鍵每次移動 1 像素，Shift+Arrow 每次移動 10 像素，Delete 可立即刪除選取圖層。這些快捷操作比拖曳更快完成微調。',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: '隱私與安全',
          title: '隱私與安全：為何瀏覽器內處理很重要',
          paragraphs: [
            '許多創作者使用線上工具時常有疑問：圖片究竟去了哪裡？在伺服器端浮水印工具中，圖片會上傳到供應商伺服器處理，再傳回你手上。這代表未公開作品、客戶照片或敏感產品圖會經過第三方基礎設施。',
            'Photremium 的浮水印工具全部在你的瀏覽器內本地處理。圖片透過瀏覽器 File API 載入到裝置記憶體，從不透過網路傳輸。浮水印渲染在 HTML5 canvas 上，由 JavaScript 在瀏覽器分頁內完成。當你關閉頁面或點擊 “Start Over”，所有圖片資料都會從記憶體釋放並丟棄。你的裝置之外不會儲存任何內容。',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: '最終總結',
          title: '為什麼 Photremium 浮水印工具值得成為你的固定工作流程',
          paragraphs: [
            '線上浮水印工具很多，真正值得收藏的工具通常取決於速度、控制力與信任感的組合。',
            '速度重要，因為浮水印不該為後製流程增加太多時間。Photremium 工具載入即時、本地處理，幾秒內就能以完整解析度輸出 — 即使是大型批次也一樣。沒有伺服器等待、沒有佇列，也不會因同時在線人數增加而延長渲染時間。',
            '控制力重要，因為看起來不對的浮水印比不加還糟 — 會讓你的品牌顯得不專業。圖層系統、屬性級控制、即時畫布預覽與快捷鍵支援，提供接近專業桌面軟體的控制體驗。',
            '信任感重要，因為未公開的作品很有價值。知道圖片從不透過網路傳到第三方伺服器，意味著你可以放心為客戶照片、未發布產品圖和敏感創作加浮水印，而不用擔心資料處理、伺服器外洩或雲端政策變更。',
            '無論是為單張照片快速加上版權提示，或在分享客戶相簿前處理 200 張照片，Photremium 浮水印工具都能讓你正確完成 — 完全免費、完全私密，並具備足夠的創意彈性，讓浮水印看起來像圖片的一部分，而不是貼在上面。',
            '前往 photremium.com/watermark-image 試試看。你的第一張浮水印圖片真的只需三十秒。',
            'Photremium 提供一整套瀏覽器內的影像編輯與處理工具。所有工具都在本地執行 — 你的圖片都留在你的裝置上。',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR 碼生成器 — 免費生成和自訂 | photremium.com',
      inputDesc: '為 URL、文字、WiFi、聯絡人、電子郵件和 Google Maps 生成自訂 QR 碼。',
      inputKeywords: 'qr 碼生成器, 製作 qr 碼, 自訂 qr 碼',
      customizeTitle: '自訂 QR 碼 — photremium.com',
      customizeDesc: '自訂您的 QR 碼的樣式、顏色、邊框和圖示。以 PNG、JPG、SVG、WEBP 或 PDF 下載。',
      customizeKeywords: '自訂 qr 碼, qr 碼樣式',
    },
    title: 'QR 碼生成器',
    desc: '為 URL、文字、WiFi、聯絡人、電子郵件和地圖生成、自訂和下載 QR 碼。',
    generate: '生成',
    scanQrCode: '掃描 QR 碼',
    tabUrl: '連結 / URL',
    tabText: '文字',
    tabWifi: 'WiFi',
    tabContact: '聯絡人',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: '輸入 URL',
    enterText: '輸入文字',
    networkName: '網路名稱 (SSID)',
    password: '密碼',
    encryption: '加密',
    hiddenNetwork: '隱藏網路',
    contactName: '聯絡人名稱（可選）',
    phoneNumber: '電話號碼',
    emailAddress: '電子郵件地址',
    subject: '主旨（可選）',
    body: '正文（可選）',
    searchLocation: '搜尋位置',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: '在此輸入您的文字…',
    wifiNamePlaceholder: '我的 WiFi',
    passwordPlaceholder: '密碼',
    contactPlaceholder: '姓名',
    phonePlaceholder: '+886 912 345 678',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: '主旨',
    bodyPlaceholder: '電子郵件正文…',
    locationPlaceholder: '搜尋城市、地址、景點…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: '無',
    characters: '個字符',
    generateCustomize: '生成並自訂',
    editQrData: '編輯 QR 資料',
    styleShape: '樣式與形狀',
    colorTab: '顏色',
    framesTab: '邊框',
    logoTab: '圖示',
    templatesTab: '模板',
    fileFormatTab: '文件格式',
    fgColor: '前景顏色',
    bgColor: '背景顏色',
    enableGradient: '啟用漸層',
    gradientType: '漸層類型',
    linear: '線性',
    radial: '放射狀',
    selectFrame: '選擇邊框',
    selectLogo: '選擇圖示',
    uploadCustomLogo: '或上傳自訂圖示',
    uploadImage: '上傳圖片',
    downloadFormat: '下載格式',
    preview: '預覽',
    downloadFormatBtn: '下載 {format}',
    pngDesc: '無損，支援透明',
    jpgDesc: '常見且通用的檔案格式',
    webpDesc: '現代格式，最佳品質/大小',
    svgDesc: '可縮放向量圖形',
    pdfDesc: '可列印文件',
    lat: '緯度：',
    lng: '經度：',
    qrCode: 'QR 碼',
    scanMe: '掃描我',
    scanHere: '在此掃描',
    blog: {
      card1: {
        title: '1. 什麼是 QR 碼？',
        intro1: 'QR 碼的完整形式是"Quick Response code"（快速回應碼）。因為其中存儲的資訊解碼非常快速，所以稱為快速回應碼（QR）。',
        intro2: 'QR 碼是一種只能由機器讀取的二維數碼。其中的數據無法由人類讀取。它包含用於存儲信息的單元格，例如文本、電話號碼、鏈接和 Google 地圖位置等。',
        inventionTitle: 'QR 碼是如何發明的：',
        inventionText: 'QR 碼於 1994 年被發明。Masahiro Hara 及其團隊在日本一家名為 Denso Wave 的公司工作，該公司為豐田生產汽車零部件。他們想要一個能夠存儲比普通條形碼更多信息的碼，因此他們發明了 QR 碼。',
        keyFeaturesTitle: 'QR 碼的主要特點',
        keyFeatures: [
          {
            title: 'QR 碼的工作原理',
            text: '您輸入文本或鏈接以生成 QR 碼。QR 生成器根據信息創建方形單元格。每個單元格代表一位，每位存儲一個字符。',
          },
          {
            title: 'QR 碼的結構',
            text: 'QR 碼包含三個大方形單元格以識別 QR 碼的方向，以及一個小方形單元格以存儲位（信息）。',
          },
          {
            title: 'QR 碼的數據容量',
            text: '通常，QR 碼存儲的信息比條形碼多。QR 碼基本上是條形碼的高級版本。它本質上是二維條形碼。QR 碼存儲近 200 個字符。它也可以存儲 400 個字符，但可能難以掃描。存儲超過 400 個字符可能會導致非常複雜的 QR 碼，幾乎無法掃描。',
          },
          {
            title: 'QR 碼中的錯誤檢測',
            text: '如果信息的一部分被劃傷或某些位被改變，QR 碼仍然可以被掃描。QR 碼使用 Reed-Solomon 錯誤檢測技術來檢測錯誤並在識別後進行更正。',
          },
        ],
        errorTitle: 'QR 碼的錯誤修正級別：',
        errorIntro: '在不同情況下使用不同的錯誤檢測和更正技術，如下所述：',
        errorHeaders: {
          level: '級別',
          recovery: '恢復能力',
          bestUse: '最佳用途',
        },
        errorRows: [
          {
            level: '低 (L)',
            recovery: '~7%',
            useCases: [
              '當 QR 碼在數字屏幕、網頁或乾淨環境中顯示時，使用此錯誤修正技術。',
              '當為小信息（如 Gmail、聯繫電話或小文本）生成 QR 碼時。',
            ],
          },
          {
            level: '中等 (M)',
            recovery: '~15%',
            useCases: [
              '用於安裝在乾淨環境中的傳單和海報，損壞風險最小時。',
            ],
          },
          {
            level: '四分位 (Q)',
            recovery: '~25%',
            useCases: [
              '當 QR 碼要在惡劣環境中安裝時，例如工廠/戶外。',
              '同時，當中心需要小徽標時，它會覆蓋幾位。因此需要此錯誤修正技術。',
            ],
          },
          {
            level: '高 (H)',
            recovery: '~30%',
            useCases: [
              '在 QR 碼可能遭受大量損害時使用。',
              '當大徽標覆蓋 QR 碼中心時。',
              '同時，當需要 QR 碼的高級樣式設計時。',
            ],
          },
        ],
      },
      card2: {
        title: '2. 為什麼選擇我們的 QR 碼生成器？',
        intro: '我們的 QR 碼生成器使生成 QR 碼變得極快、安全和容易。您可以自定義您的碼以使其更高級、更專業並適應您公司的主題。所有自定義，從 QR 碼著色到在 QR 碼中安裝徽標，都永久免費提供。',
        strengths: [
          {
            title: '專業自定義：',
            text: '您可以無限量地生成和自定義 QR 碼，無需任何成本。所有功能完全免費。您可以應用漸變色、不同的方形形狀、自定義徽標和許多其他功能。',
          },
          {
            title: '支持多種格式：',
            text: '我們的 QR 碼生成器提供多種下載格式供您方便。只需在下載前選擇您喜歡的格式。目前我們提供這些格式：',
          },
          {
            title: '預製模板：',
            text: '您可以使用預製漸變色和框架，使您的 QR 碼看起來專業。',
          },
          {
            title: '自定義徽標支持：',
            text: '您還可以上傳自定義品牌徽標，它會自動適應 QR 碼的中心。您也可以從內置徽標庫中選擇徽標，其中有 30 多個徽標可用。',
          },
          {
            title: '即時預覽：',
            text: '自定義時，您可以在即時預覽面板中觀察所有更改。這些預覽面板中的更改是實時的並動態變化。',
          },
          {
            title: '掃描指示器：',
            text: '選擇顏色時，如果您選擇難以掃描的顏色，適當的警告和指示器將指導您。',
          },
        ],
        formatHeaders: {
          srNo: '序號',
          formats: '格式',
          description: '描述',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: '無損，支持透明度' },
          { no: '2', format: 'JPG', description: '常見、通用文件格式' },
          { no: '3', format: 'WEBP', description: '現代、最佳品質/大小' },
          { no: '4', format: 'SVG', description: '可縮放向量圖形' },
          { no: '5', format: 'PDF', description: '可打印文件' },
        ],
      },
      card3: {
        title: '3. 逐步指南：',
        step1Intro: '首先，選擇您想生成的 QR 碼類別。如果您為聯繫人、地圖、鏈接或文本生成 QR 碼。目前，我們的 QR 碼生成器提供這些類別：',
        categories: ['鏈接 / URL', '文本', 'WiFi', '聯繫人', 'Gmail', 'Google 地圖'],
        step2: '選擇類別後，將您的信息粘貼到文本字段中。',
        step3Intro: '然後，點擊"生成並自定義"以打開自定義面板。在自定義面板中，您將看到一個導航欄，包含以下選項：',
        options: [
          {
            title: '樣式和形狀：',
            text: '在本節中，您可以將方形形狀更改為許多其他樣式，例如圓角、點、水平條、垂直條、小方形等。',
          },
          {
            title: '顏色：',
            text: '在本節中，您可以選擇自定義背景和前景色。要使用漸變色創建 QR 碼，您有啟用漸變的選項，允許您從內置庫應用任何漸變色或輕鬆創建漸變色。您也可以更改線性漸變色的角度。也支持徑向漸變。您可以添加多種顏色以創建專業漸變效果。',
          },
          {
            title: '框架：',
            text: '在這裡，您可以為您的 QR 碼選擇完美的框架。所有框架會自動適應您的碼。只需從內置庫中選擇一個框架。',
          },
          {
            title: '徽標：',
            text: '選擇框架後，您可以選擇一個徽標，它將自動調整到 QR 碼的中心。也支持上傳自定義品牌徽標。',
          },
          {
            title: '模板：',
            text: '如果您不想分別選擇樣式、形狀、顏色和框架，您可以為 QR 碼應用預製模板。許多高級模板可供您方便使用，永久免費。',
          },
          {
            title: '文件格式：',
            text: '最後，您必須選擇要下載 QR 碼的文件類型。支持多種常見格式，包括 PNG、WEBP、SVG 和 PDF 等。',
          },
          {
            title: '編輯 QR 數據：',
            text: '您也可以編輯 QR 數據而不會丟失任何選定的自定義。',
          },
        ],
        finalStep: '然後，只需點擊下載按鈕，QR 碼將按照您的自定義內容以選定的格式立即下載，無需任何費用。',
      },
      card4: {
        title: '4. 優點：',
        intro: 'QR 碼連接物理世界和數字體驗。這是共享鏈接、聯繫人或您的位置最快的方式。只需掃描 QR 碼即可立即訪問信息。這就是為什麼它在商業和數字世界中極其流行，因為它節省時間並很有目的性。',
        benefits: [
          {
            title: '終身支持：',
            text: 'QR 碼永遠有效，沒有過期日期。當您掃描它們時，它們會立即為您提供存儲的信息。因為它包含固定編碼的數字指令，它永遠不會丟失信息。',
          },
          {
            title: '離線支持：',
            text: '即使離線，您也可以掃描 QR 碼。您的手機攝像頭解碼 QR 碼圖案並為您提供其中存儲的信息。',
          },
          {
            title: '零成本：',
            text: '由於這些碼不需要任何服務器重定向或資源，它們永遠免費。',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR 碼掃描器 — 從相機或圖片掃描 QR 碼 | photremium.com',
      desc: '通過相機或圖片上傳即時掃描 QR 碼。偵測 URL、文字、WiFi、聯絡人等。',
      keywords: 'qr 碼掃描器, 掃描 qr 碼, qr 閱讀器, 線上 qr 碼',
    },
    title: 'QR 碼掃描器',
    desc: '通過相機或圖片上傳即時掃描 QR 碼。快速且安全。',
    generateQrCode: '生成 QR 碼',
    scan: '掃描',
    cameraScanner: '相機掃描器',
    uploadImage: '上傳圖片',
    pointCamera: '將相機對準 QR 碼',
    startCamera: '啟動相機',
    loading: '載入中…',
    dropQrImage: '將 QR 碼圖片放到此處',
    toScan: '要掃描',
    supportedFormats: '支援 JPG、PNG、GIF、WEBP',
    ctrlVPaste: 'Ctrl+V 貼上',
    scanFromGallery: '從相簿掃描',
    accessingCamera: '正在訪問相機…',
    cameraDenied: '相機訪問被拒絕。請允許相機權限並重試。',
    noCamera: '此設備未找到相機。',
    cameraError: '無法訪問相機。請重試。',
    tryAgain: '再試一次',
    switchCamera: '切換相機',
    stop: '停止',
    noQrFound: '未找到 QR 碼',
    couldNotRead: '無法讀取圖片',
    scannerFailed: '掃描器載入失敗',
    noQrFoundDesc: '在圖片中未偵測到 QR 碼。請嘗試其他圖片或使用相機掃描器。',
    qrScanned: 'QR 碼已掃描！',
    openLink: '開啟連結',
    copied: '已複製！',
    copy: '複製',
    share: '分享',
    scanAgain: '再次掃描',
    network: '網路',
    password: '密碼',
    security: '安全性',
    unknown: '未知',
    blog: {
      tocTitle: '目錄',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. 為什麼要使用 QR Code 掃描器？',
          paragraphs: [
            'QR Code 掃描器本質上就是可解碼 QR Code 內容的行動裝置相機。你只需要把相機對準 QR Code；不論方向如何，掃描器都會讀取特定圖樣、偵測錯誤、在需要時修正錯誤，並顯示其中資訊。',
          ],
          listTitle: 'QR Code 掃描器類型：',
          bullets: [
            '網頁式 QR Code 掃描器：你可以使用瀏覽器支援的線上掃描器掃描 QR Code。可透過相機或上傳圖片取得資訊。若要使用自動導向與其他進階功能，可前往 https://photremium.com。',
            '手機相機：部分現代手機在原生相機 App 內建 QR 掃描功能。只要對準 QR Code，即可擷取並解碼資訊。',
            '應用程式：有些 App 專門用於掃描 QR Code。不過，若你需要進階導向和更多功能，也可透過此連結免費安裝/使用： https://photremium.com。',
            '硬體裝置：也有專用硬體可用來掃描 QR Code。這些裝置常見於大型購物中心的結帳場景。',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. 為什麼選擇我們的 QR Code 掃描器？',
          paragraphs: [
            '你可以使用多種進階功能，從導向到複製 QR 解碼內容都包含在內。我們的 QR Code 掃描器也提供許多實用功能，例如：',
          ],
          bullets: [
            '高速解碼：我們的 QR Code 掃描器可極速完成解碼。只要掃描 QR Code，工具就會即時顯示資訊，並提供複製文字/連結、偵測到連結時直接開啟、偵測到聯絡人時自動儲存等進階選項。',
            '免安裝：使用我們的 QR Code 掃描器不需要額外安裝 App。可直接在瀏覽器中免費使用。',
            '跨平台可用：可在各種裝置上使用。不必擔心作業系統版本或額外要求。',
            '完整格式支援：可辨識 QR Code 常見資料格式，包括純文字、WiFi、URL、聯絡人、Gmail、Google Maps 等。',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. 逐步指南：',
          steps: [
            {
              heading: '1. 首先，選擇掃描 QR Code 的方式。共有以下兩種方法：',
              subSteps: [
                {
                  heading: 'i. 相機方式',
                  paragraphs: [
                    '即使你使用的是筆電、桌機，或任何支援一般相機的裝置，也可以透過裝置相機掃描 QR Code。只要點擊「啟動相機」按鈕，就會跳出權限請求；請允許本站使用相機進行 QR 掃描。若你不小心拒絕或沒有看到權限提示，也可依照下列步驟手動開啟相機權限：',
                  ],
                  notes: [
                    '➔ Chrome（Android / Desktop）:',
                    '1. 點擊右上角三個點',
                    '2. 進入設定',
                    '3. （Android 可略過）隱私與安全性',
                    '4. 點擊網站設定',
                    '5. 在權限區塊點擊相機',
                    '6. 找到本站 URL： https://photremium.com/qr-code-scanner',
                    '7. 在下拉選單中把相機設為允許。',
                    '➔ Safari（iPhone / iOS）:',
                    '1. 點擊網址列中的 AA 或 Website Settings 圖示。',
                    '2. 選擇 Website Settings。',
                    '3. 點擊 Camera 並選擇 Allow。',
                    '4. 若仍被封鎖：前往 iPhone 設定 > Safari > Camera，設為 Ask 或 Allow。',
                  ],
                },
                {
                  heading: 'ii. 相簿方式',
                  paragraphs: [
                    '你可以上傳 QR Code 圖片來取得資訊。點擊「從相簿掃描」按鈕後會開啟檔案總管，再選取 QR Code 圖片即可。支援多種圖片格式，如 .jpg、.jpeg、.png、.gif、.webp、.svg、.avif、.heic、.heif、.jxl、.bmp、.ico、.tiff、.tif、.jfif、.jpe、.pjpeg、.pjp、.apng、.svgz、.xbm 等。',
                  ],
                },
              ],
            },
            {
              heading: '2. 當你選擇 QR Code 後，所有資訊都會顯示；你可以複製、分享，若偵測到連結也可直接開啟。你也可以隨時再次掃描。',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'QR Code 掃描器的優點：.',
          paragraphs: [
            'QR Code 掃描器在數位場景中具備多項優勢。它讓付款、驗證與資訊存取更快速、更方便，離線模式也能使用。',
          ],
          bullets: [
            '資訊即時取得：掃描 QR Code 可在毫秒內取得資訊。系統會快速解碼圖樣、偵測並修正錯誤，帶來極速體驗。',
            '溝通更順暢：在現代環境中，銀行資訊、產品資訊等小型資料也需要快速且安全地傳遞。QR 掃描器可有效改善這點。許多支付流程透過 QR 進行，Google 在筆電建立新帳號時也可能使用 QR 進行手機驗證。',
            '電子票證：在客運站、火車站或機場，你可以更快速完成票券驗證，減少排隊時間。機場多點部署 QR 掃描器也可降低壅塞、減少人力需求並節省營運成本。',
            '商品真偽驗證：高階品牌常在產品上附上 QR Code。消費者可透過掃描快速檢查商品是否為正品。',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: '人臉模糊工具 — 線上模糊圖片中的人臉 | photremium.com',
      uploadDesc: '使用 AI 人臉偵測自動模糊圖片中的人臉。選擇模糊強度、形狀或表情符號。',
      uploadKeywords: '人臉模糊, 模糊人臉, 人臉偵測, 隱私工具',
      workspaceTitle: '人臉模糊工具 — photremium.com',
      workspaceDesc: '自動模糊圖片中的人臉。100% 免費。',
      workspaceKeywords: '人臉模糊, 人臉偵測',
    },
    title: '人臉模糊',
    desc: '自動偵測並模糊圖片中的人臉以保護隱私。',
    toBlurFaces: '要模糊人臉',
    autoDetection: '自動偵測',
    autoDetectionDesc: 'AI 人臉偵測即時找出所有人臉',
    customBlur: '自訂模糊',
    customBlurDesc: '調整模糊強度、形狀和樣式',
    private100: '100% 私密',
    private100Desc: '所有處理都在瀏覽器本地進行',
    blurTools: '模糊工具',
    faces: '人臉',
    faceDetection: '人臉偵測',
    detecting: '偵測中...',
    autoDetectFaces: '自動偵測人臉',
    exitManualMode: '退出手動模式',
    manualSelect: '手動選擇',
    nFaceRegions: '找到 {n} 個人臉區域',
    noFacesDetected: '未偵測到人臉 — 使用手動模式',
    manualHint: '點擊並拖曳以在圖片上要模糊的區域上繪製矩形。',
    blurType: '模糊類型',
    blur: '模糊',
    emoji: '表情符號',
    blurIntensity: '模糊強度',
    strength: '強度',
    blurShape: '模糊形狀',
    rectangle: '矩形',
    ellipse: '橢圓形',
    circle: '圓形',
    chooseEmoji: '選擇表情符號',
    blurRegionsN: '模糊區域 ({n})',
    faceN: '人臉 {n}',
    manualRegionN: '手動區域 {n}',
    manualN: '手動 {n}',
    clearAllRegions: '清除所有區域',
    processingDots: '處理中...',
    downloadBlurred: '下載模糊圖片',
    downloadNImages: '下載 {n} 張圖片',
    downloadDialogTitle: '並非所有圖片都已編輯',
    downloadDialogText: '您已編輯 {total} 張中的 {edited} 張。',
    downloadAll: '全部下載',
    removeRegion: '移除區域',
    region: '區域',
    notAllEdited: '並非所有圖片都已編輯',
    editedXofY: '您已編輯 {total} 張中的 {edited} 張。',
    nextImage: '下一張圖片',
  },

  faqData: {
    imageConverter: [
      { q: '轉換支援哪些圖片格式？', a: '我們支援 JPG、PNG、WEBP、SVG、GIF、BMP、ICO 和 TIFF。您可以在瀏覽器中即時在這些格式之間進行轉換。' },
      { q: '轉換過程中圖片品質會受影響嗎？', a: '對於 PNG 等無損格式，品質完全保留。對於 JPG 和 WEBP 等有損格式，我們使用優化的編碼設定來保持最佳視覺品質。' },
      { q: '文件大小或數量有限制嗎？', a: '沒有嚴格限制。您可以一次上傳多張圖片並批量轉換。' },
      { q: '我的資料安全嗎？圖片會上傳到伺服器嗎？', a: '絕對安全。所有處理都在您的瀏覽器中進行。您的圖片永遠不會離開您的設備。' },
      { q: '我可以將透明 PNG 圖片轉換為 JPG 嗎？', a: '可以。由於 JPG 不支援透明度，透明區域默認填充為白色背景。' },
    ],
    imageCompressor: [
      { q: '壓縮圖片會降低品質嗎？', a: '不會，除非您把壓縮比例拉到超過建議範圍，否則圖片品質基本不會受影響。系統會以指示色提示品質： i. 壓縮 1% 到 40%：顯示綠色「良好品質」。 ii. 壓縮 41% 到 60%：顯示黃色「一般品質」，通常建議使用此區間。 iii. 壓縮 61% 到 100%：系統會顯示紅色「低品質」警示，此區間的畫質下降可能會較明顯。' },
      { q: '壓縮支援哪些圖片格式？', a: '我們的圖片壓縮工具支援以下全部格式：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '可以一次壓縮多張圖片嗎？', a: '當然可以。只要您的裝置效能足夠，就可以一次壓縮多張圖片（甚至 100+）。由於壓縮會使用本機資源，效能越高處理越快。若裝置效能較低，也可以分批壓縮；本工具免費使用，分多批也沒問題。' },
      { q: '你們會上傳或儲存我的圖片到伺服器嗎？', a: '不會。我們不會上傳或儲存您的圖片。所有壓縮都在您的瀏覽器本機完成，圖片不會離開您的裝置，因此可安心處理個人或私密圖片。' },
      { q: '這個圖片壓縮工具是免費的嗎？', a: '是的，我們的圖片壓縮工具永久免費。您不需要支付任何費用，也沒有隱藏收費。包含多圖批量壓縮在內的所有功能都可免費使用。' },
    ],
    cropImage: [
      { q: '裁剪圖片會降低品質嗎？', a: '不會，裁剪圖片完全不會影響圖片的視覺品質。裁剪只是移除不需要的部分，不會改變保留區域中的像素。因此，您可以在無像素損失的情況下，以原始品質裁剪圖片。' },
      { q: '圖片裁剪工具支援哪些圖片格式？', a: '由於我們的圖片裁剪工具支援幾乎所有圖片格式，您可以選擇任何格式的圖片。支援格式如下：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '我的圖片會上傳到你們伺服器嗎？', a: '不會，所有處理都在您的本機瀏覽器中完成。圖片不會離開您的裝置，因此不會上傳到我們的伺服器。您可以無風險地使用我們的圖片裁剪工具處理私人圖片。' },
      { q: '我可以一次裁剪多張圖片嗎？', a: '可以，如果您的系統支援，您可以一次裁剪多張圖片（甚至 100+）。由於圖片裁剪會使用系統資源，若您使用高效能筆電、電腦或手機，就能同時處理更多圖片。若裝置效能較低，也可分批裁剪；即使大量使用，本工具仍然免費。' },
      { q: '這個圖片裁剪工具是免費的嗎？', a: '是的，這個圖片裁剪工具永久完全免費。您可隨時隨地在任何裝置上使用。您不僅可獲得適配所有裝置的響應式體驗，也不會被要求支付任何進階功能費用。所有功能都完全免費且沒有隱藏費用。' },
    ],
    resizeImage: [
      { q: '我可以一次調整多張圖片大小嗎？', a: '可以，當然可以。我們的工具支援多張圖片同時調整大小。您可依裝置能力上傳多張圖片，AI 引擎會同時處理。若裝置效能較低，建議分批處理以避免卡頓。所有處理都在本機完成，不會上傳到伺服器，隱私更有保障。' },
      { q: '這個圖片尺寸調整工具是免費的嗎？', a: '是的，這個工具永久完全免費。不需要付費訂閱也能使用進階功能。下載調整後圖片時也沒有任何隱藏費用。' },
      { q: '調整圖片大小會降低品質嗎？', a: '✅Decrease Size (downscale): 縮小圖片通常不會降低視覺品質。很多情況下，縮小後的圖片看起來甚至更銳利。因此縮小到更小尺寸一般不會造成畫質損失。\n❌Increase Size (upscale): 將圖片放大超過原始尺寸可能會影響視覺品質。放大幅度越大，畫質下降的可能性越高。' },
      { q: '這個工具安全嗎？', a: '是的，我們的工具非常安全，特別適合個人或敏感圖片。所有處理都在您的裝置本機完成，資料不會離開裝置。您可安心調整尺寸，不必擔心隱私風險。' },
      { q: '支援哪些圖片格式？', a: '我們的圖片尺寸調整工具支援所有常見圖片格式。可選擇以下格式：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: '背景移除如何工作？', a: '我們使用直接在瀏覽器中執行的高級 AI 模型來偵測主體並將其與背景分離。' },
      { q: '它適用於複雜背景嗎？', a: '可以。AI 模型可以處理各種場景。當主體和背景之間有清晰對比時，效果最佳。' },
      { q: '可以同時從多張圖片中移除背景嗎？', a: '可以。上傳多張圖片，工具會依序處理它們。' },
      { q: '輸出格式是什麼？', a: '輸出始終是帶有透明背景的 PNG 文件。' },
      { q: '我的圖片會被發送到伺服器嗎？', a: '不會。AI 模型使用 WebAssembly 完全在瀏覽器中執行。' },
    ],
    watermarkImage: [
      { q: '1. Photremium 的浮水印工具完全免費嗎？', a: '是的，photremium.com/watermark-image 上的浮水印工具可免費使用，不需要帳號，也不需要訂閱。您可以替單張圖片或整批圖片加上浮水印，不會有付費牆、強制註冊提示或下載限制。這個工具之所以免費，是因為讓整個 Photremium 平台本身足夠有價值，讓使用者願意回來，而不是靠鎖住單一功能收費。' },
      { q: '2. 我一次可以替多少張圖片加浮水印？', a: '此工具支援批次為多張圖片同時加上浮水印。您可以把整個圖片資料夾直接拖放到上傳區，也可以在檔案選擇器中按住 Ctrl 點選，一次選取數十個檔案。左側縮圖列會顯示所有圖片，點擊「Watermark & Download All」後，工具會先依照您的設定為每張圖片渲染浮水印圖層，再將它們打包成單一 ZIP 檔，或依您的選擇分開下載。實際批次大小主要受限於裝置可用記憶體，而不是工具本身的人為上限。' },
      { q: '3. 支援哪些輸入和輸出圖片格式？', a: '輸入端接受瀏覽器 File API 能處理的所有圖片格式，實際上包括 JPEG、JPG、PNG、WEBP、GIF（靜態）、BMP 和 SVG。輸出格式會與原始圖片一致：上傳 PNG 就會回傳 PNG，上傳 JPEG 就會回傳品質 0.95 的 JPEG。這種格式保留方式可避免您不小心把無損 PNG 轉成有損 JPEG。' },
      { q: '4. 不同解析度的圖片上，浮水印看起來會一樣嗎？', a: '會，這要歸功於工具的比例重定位引擎。當您批次處理不同尺寸的圖片時，浮水印會先在參考圖片上編輯，也就是您在畫布中選取的那張。匯出時，系統會計算參考圖片上每個浮水印圖層的重心，將位置表示為相對於圖片中心的比例位移，然後把相同的比例位移套用到每張目標圖片上。浮水印尺寸也會按比例縮放，並採用寬高兩個縮放因子中較小的一個，確保不會超出圖片邊界。這樣一來，即使圖片尺寸不同，浮水印的相對位置與大小也能維持一致。' },
      { q: '5. 我可以用自己的 Logo 或簽名取代文字浮水印嗎？', a: '當然可以。右側面板裡的「Add Image」按鈕可讓您從裝置上傳任何圖片作為浮水印圖層。具透明背景的 PNG 效果最好，因為透明區域會被保留，這樣只會顯示 Logo 本身，不會出現白色或有色底框。您可以拖曳角點縮放、旋轉、翻轉、調整不透明度，甚至加上邊框或圓角。許多使用者會專門保留一個透明背景版本的 Logo 來當作浮水印。' },
      { q: '6. 我要如何把浮水印調成透明或半透明？', a: '先在畫布上點選浮水印圖層將其選取。上方出現的工具列裡有不透明度控制項，會顯示百分比，您可以直接輸入數值，也可以拖曳滑桿。若想要低調、專業且不搶主體的浮水印，30–50% 的不透明度通常最合適。若想要更明顯、更醒目的版權提示，70–80% 的效果不錯。您也可以在圖層管理器裡用「眼睛」圖示切換圖層可見性，快速比較有無浮水印的差異。' },
      { q: '7. 一張圖片裡可以加入多個浮水印嗎？', a: '可以，圖層系統支援無限數量的浮水印圖層，而且每個圖層都能單獨設定。您可以同時放一個右下角的文字版權聲明、一個左上角的 Logo，以及一個鋪滿全圖的 “SAMPLE” 平鋪層。每個圖層都有自己的不透明度、旋轉、位置、尺寸與樣式設定。右側面板的圖層管理器會幫您整理這些圖層，而且您可以單獨開啟或關閉某個圖層，不必刪除它們，方便在最後匯出前嘗試不同組合。' },
      { q: '8. 平鋪功能是做什麼的，什麼時候該用？', a: '平鋪會把浮水印以網格模式重複鋪滿整張圖片。Grid 2×2 會把四個副本排成二乘二；Grid 3×3 會把九個副本排成三乘三。tile spacing 控制項可調整各副本之間的間距。平鋪最適合用在您希望圖片在未獲授權前無法直接使用的情境。角落裡的單一浮水印很容易被裁掉，但全覆蓋的平鋪圖案會讓圖片在沒有浮水印的情況下幾乎無法使用。這種方式常用於合約預覽、給客戶確認的草稿圖，或任何在付款前不應被自由使用的內容。' },
      { q: '9. 這個工具可以在手機與平板上使用嗎？', a: '可以，這個工具完全響應式，並且針對行動裝置使用而設計。在寬度小於 900 像素的螢幕上，三欄版面會切換成堆疊式：縮圖列變成頂部可水平捲動的一列，畫布佔據主要區域，設定面板則變成底部抽屜，點擊浮動齒輪按鈕時會滑上來。所有互動元素，包括圖層拖曳、縮放把手與旋轉，都支援觸控，並使用 touchstart 與 touchmove 事件。行動端的縮放把手也稍微放大到 16×16 像素，比桌面版更容易用手指準確點到。' },
      { q: '10. 我的圖片資料是否私密？照片會上傳到伺服器嗎？', a: '您的圖片永遠不會離開您的裝置。整個浮水印流程，包括載入圖片、渲染圖層與匯出最終檔案，都是在瀏覽器中透過 JavaScript 與 HTML5 Canvas API 完成。當您上傳圖片時，File API 會在記憶體中建立該檔案的表示；當您加入浮水印圖層時，它會被繪製到一個離螢幕的 canvas 元素上；當您下載結果時，canvas 的像素資料會被轉成 Blob 並交給瀏覽器下載，全程都在本機完成。沒有任何涉及圖片資料的網路請求。此外，工具還有離開頁面保護：如果圖片已載入時您嘗試關閉或跳轉頁面，瀏覽器會要求確認，以避免不小心遺失未完成的工作。' },
    ],
    qrCodeGenerator: [
      { q: 'QR碼會過期嗎?', a: '不會，這些QR碼不會過期，並保證終身支持。由於它們以位元的形式存儲硬編碼指令在方形框內，存儲在其中的信息無法更改或刪除。即使多年後，您也可以用任何相機掃描代碼來訪問信息。' },
      { q: '為什麼我的QR碼無法掃描?', a: '您的QR碼可能因以下原因掃描失敗：i. 低對比度：如果您選擇相似的背景和前景顏色，會影響QR碼的可見性並導致掃描失敗。但我們的工具會在自定義期間指導您關於低對比度或任何其他掃描相關問題。ii. 大量數據：如果您為非常大的文本或數據生成QR碼，它會變得非常複雜並在掃描時造成問題。文本長度驗證器會指導您在QR碼生成期間了解最佳文本長度。iii. 模糊打印：確保以高分辨率格式（如PNG或SVG）下載QR碼，我們的工具已支持這些格式。' },
      { q: '我可以在QR碼中添加徽標嗎?', a: '當然可以，您可以添加自定義徽標或從內置徽標庫中為您的QR碼選擇一個。您選擇的徽標將自動調整到QR碼的中心。' },
      { q: '我如何掃描QR碼?', a: '您可以使用手機攝像頭掃描QR碼。但是為了自動重定向到鏈接和許多其他高級功能，您可以免費訪問我們的QR碼掃描儀 https://photremium.com/qr-code-scanner。' },
      { q: '我可以免費生成多少QR碼?', a: '無限制！您可以免費生成多個QR碼。所有功能、自定義和模板對所有人免費永久提供。無需訂閱即可享受高級功能。' },
      { q: '生成QR碼需要登錄/註冊嗎?', a: '不需要，只需輸入文本、生成QR碼，然後在自定義後下載。由於所有功能都可以完全免費訪問，因此無需登錄或註冊。' },
    ],
    qrCodeScanner: [
      { q: '我可以從已儲存圖片與螢幕截圖掃描 QR Code 嗎？', a: '**可以**，你可以從已儲存圖片或螢幕截圖掃描 QR Code。我們的 QR Code 掃描器 https://photremium.com/qr-code-scanner 支援從相簿掃描。你只需選取圖片，就能取得該 QR Code 解碼出的完整資訊。' },
      { q: '使用 QR Code 掃描器需要安裝 App 嗎？', a: '**不需要**，我們的網頁式 QR Code 掃描器不需安裝任何 App。你可在任何裝置上免費使用進階 QR 掃描功能。' },
      { q: '為什麼掃描器無法辨識 QR Code？', a: '你的 QR Code 可能因以下原因無法掃描：i. 光線不足：在昏暗環境中掃描容易失敗。若你從螢幕掃描，請開啟手電筒並提高亮度。ii. 距離不當：距離太近或太遠都會影響辨識。建議距離約 10 吋（25cm）。iii. 鏡頭髒污：相機鏡頭髒也會導致掃描失敗。請先清潔鏡頭再掃描。『你有看到掃描框格線嗎？把 QR Code 放進框內可提高成功率。』' },
      { q: '此工具可以掃描反相或彩色 QR Code 嗎？', a: '**可以**，你可掃描任何顏色與方向的 QR Code。不過若前景與背景對比過低，掃描難度會提高。' },
      { q: '此工具是免費的嗎？', a: '**是的**，此工具完全免費。你可永久免費、無限制掃描 QR Code。' },
    ],
    faceBlur: [
      { q: '人臉偵測如何工作？', a: 'AI 驅動的人臉偵測模型直接在您的瀏覽器中執行。它識別圖片中的人臉。' },
      { q: '可以選擇要模糊哪些人臉嗎？', a: '可以。偵測後，每個人臉區域都會被突顯，您可以選擇要模糊哪些人臉。' },
      { q: '可以使用哪些模糊樣式？', a: '您可以選擇高斯模糊、像素化或純色覆蓋，並調整強度。' },
      { q: '可以同時在多張圖片上模糊人臉嗎？', a: '可以。上傳多張圖片，配置模糊區域，然後下載所有處理後的圖片。' },
      { q: '我的照片是否發送到遠端伺服器？', a: '不會。AI 模型使用 WebAssembly 在您的瀏覽器中執行。' },
    ],
    photoEditor: [
      { q: '有哪些編輯功能？', a: '亮度、對比度、飽和度調整，套用濾鏡，添加文字、疊加效果、邊框和貼圖 — 全在瀏覽器中完成。' },
      { q: '可以撤銷和重做更改嗎？', a: '可以。編輯器支援完整的撤銷/重做歷史記錄。' },
      { q: '可以編輯和匯出哪些文件格式？', a: '您可以編輯 JPG、PNG、WEBP 和其他常見格式。' },
      { q: '編輯器在手機上有效嗎？', a: '有效。編輯器完全響應式且對觸控友好。' },
      { q: '我的圖片是否儲存在伺服器上？', a: '不會。所有編輯都在本地進行。' },
    ],
  },
};

export default zhTw;
